import { useFormik } from "formik";
import { observer } from "mobx-react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect } from "react";
import {
  ContactGroup,
  ContactType,
} from "../../../api/firebase/types/contact.types";
import ContactStore from "../../../store/ContactStore";
import ContactPickList from "../../../components/pickList/ContactPickList";

export type ContactGroupSettingsFormData = Pick<
  ContactGroup,
  "label" | "description" | "contactIds"
>;

type ContactGroupSettingsFormProps = {
  currentContactGroup: ContactGroup;
  onSave: (contactGroup: ContactGroupSettingsFormData) => void;
};

export const fieldIds = {
  label: "label",
  description: "description",
  contactIds: "contactIds",
};

const ContactGroupSettingsForm: React.FC<ContactGroupSettingsFormProps> = ({
  currentContactGroup,
  onSave,
}) => {
  const contacts = ContactStore.contacts;
  const formik = useFormik<ContactGroupSettingsFormData>({
    initialValues: {
      label: currentContactGroup?.label,
      description: currentContactGroup?.description,
      contactIds: currentContactGroup?.contactIds,
    },
    validate: () => {},
    onSubmit: async (data) => {
      onSave(data);
    },
  });

  useEffect(() => {
    formik.setValues({
      label: currentContactGroup?.label,
      description: currentContactGroup?.description,
      contactIds: currentContactGroup?.contactIds,
    });
  }, [currentContactGroup?.id]);

  const isFormFieldValid = (name: keyof ContactGroupSettingsFormData) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name: keyof ContactGroupSettingsFormData) =>
    isFormFieldValid(name) ? (
      <small className="p-error p-d-block form-error">
        {formik.errors[name]}
      </small>
    ) : undefined;

  const selectedContacts: ContactType[] = [];
  const unselectedContacts: ContactType[] = [];

  contacts.forEach((contact) => {
    if (currentContactGroup.contactIds.includes(contact.id)) {
      selectedContacts.push(contact);
      return;
    }
    unselectedContacts.push(contact);
  });

  return (
    <form id="contactGroupSettings" onSubmit={formik.handleSubmit}>
      <h3>Bezeichnung</h3>
      <InputText
        id="label"
        className="p-m-2"
        value={formik.values.label}
        onChange={formik.handleChange}
        placeholder="z.B. Management"
      />
      {getFormErrorMessage("label")}
      <h3>Beschreibung</h3>
      <InputTextarea
        id="description"
        value={formik.values.description}
        onChange={formik.handleChange}
        className="p-m-2"
        placeholder="z.B. Kontaktgruppe bestehend aus allen Führungskräften"
        rows={5}
        cols={50}
        autoResize
      />
      <h3>Kontakte</h3>
      <ContactPickList
        selectedContactIds={formik.values.contactIds}
        onChange={(contactIds) =>
          formik.setFieldValue("contactIds", contactIds)
        }
      />
    </form>
  );
};

export default observer(ContactGroupSettingsForm);
